import React, { useEffect, useState } from 'react'

import '../Tables.css'
import TableTestsRow from './TableTestsRow'

// const defaultData = [
//     {
//         name: 'Основные методы биологии',
//         result: '100%',
//         groupResult: '95%',
//         date: '06.04.2023',
//         time: '02:30:00',
//         attempts: '1',
//         answers: 'Посмотреть ошибки',
//     },
//     {
//         name: 'Основные методы биологии',
//         result: '100%',
//         groupResult: '95%',
//         date: '06.04.2023',
//         time: '02:30:00',
//         attempts: '1',
//         answers: 'Посмотреть ошибки',
//     },
//     {
//         name: 'Основные методы биологии',
//         result: '100%',
//         groupResult: '95%',
//         date: '06.04.2023',
//         time: '02:30:00',
//         attempts: '1',
//         answers: 'Посмотреть ошибки',
//     },
//     {
//         name: 'Основные методы биологии',
//         result: '100%',
//         groupResult: '95%',
//         date: '06.04.2023',
//         time: '02:30:00',
//         attempts: '1',
//         answers: 'Посмотреть ошибки',
//     },
//     {
//         name: 'Основные методы биологии',
//         result: '100%',
//         groupResult: '95%',
//         date: '06.04.2023',
//         time: '02:30:00',
//         attempts: '1',
//         answers: 'Посмотреть ошибки',
//     },
//     {
//         name: 'Основные методы биологии',
//         result: '100%',
//         groupResult: '95%',
//         date: '06.04.2023',
//         time: '02:30:00',
//         attempts: '1',
//         answers: 'Посмотреть ошибки',
//     },

// ]
const defaultMetrics = [
  {
    name: 'title',
    orderType: 'asc',
  },
  {
    name: 'user_result',
    orderType: 'asc',
  },
  {
    name: 'datetime',
    orderType: 'asc',
  },
  {
    name: 'time_spent',
    orderType: 'asc',
  },
  {
    name: 'attempt',
    orderType: 'asc',
  },
]
const TableTests = ({ data, isLoading }) => {
  const [sortingData, setSortingData] = useState(defaultMetrics)
  const [sortedData, setSortedData] = useState(data)
  console.log(data)
  useEffect(() => {
    setSortedData(data)
  }, [data])

  const handleSort = (index) => {
    // console.log(sortedData)

    let sortedArray = [...sortedData]
    let newOrderType = sortingData[index].orderType === 'asc' ? 'desc' : 'asc'

    if (index === 1) {
      // Результат
      sortedArray.sort((a, b) => {
        const resultA = parseFloat(a.user_result)
        const resultB = parseFloat(b.user_result)
        return newOrderType === 'asc' ? resultA - resultB : resultB - resultA
      })
    }

    if (index === 2) {
      // Дата создания
      sortedArray.sort((a, b) => {
        const dateA = new Date(a.created_at)
        const dateB = new Date(b.created_at)
        return newOrderType === 'asc' ? dateA - dateB : dateB - dateA
      })
    }

    const newSortingData = sortingData.map((item, i) => {
      if (i === index) {
        return { ...item, orderType: newOrderType }
      }
      console.log(item)

      return item
    })

    setSortedData(sortedArray)
    setSortingData(newSortingData)
  }
  return (
    <div className="tableCourses__container">
      <div className="tableTests__top">
        <div className="tableTests__names tableTests__result">
          Сортировать:{' '}
          <span onClick={() => handleSort(2)}>по дате создания</span>
          <div
            className={`sortable ${
              sortingData[2].orderType === 'asc' ? 'rotated' : ''
            }`}
          ></div>
        </div>
        <div className="tableTests__results">
          <div className="tableTests__result" onClick={() => handleSort(2)}>
            Дата создания
            {/* <div className={`sortable ${sortingData[2].orderType === 'asc' ? 'rotated' : ''}`}></div> */}
          </div>
          <div>Результат группы</div>
          <div className="tableTests__result" onClick={() => handleSort(1)}>
            Результат
            <div
              className={`sortable ${
                sortingData[1].orderType === 'asc' ? 'rotated' : ''
              }`}
            ></div>
            {/* <div className={`sortable ${sortingData[1].orderType === 'asc' ? 'rotated' : ''}`}></div> */}
          </div>
          <div className="tableTests__result" onClick={() => handleSort(4)}>
            Попытка
            {/* <div className={`sortable ${sortingData[4].orderType === 'asc' ? 'rotated' : ''}`}></div> */}
          </div>
          <div></div>
        </div>
      </div>
      <div className="tableCourses__main">
        {isLoading && <div className="isLoading">Загрузка...</div>}
        {sortedData &&
          sortedData.map(
            (i) => (
              // im.testDetails && im.testDetails.map((i, index) => (i.title && i.user_result) && (
              <TableTestsRow
                key={i.id}
                name={i.title}
                result={`${Number(i.user_result)}%`}
                groupResult={`${Number(i.group_result)}%`}
                date={i.created_at}
                time={i?.time_spent}
                attempts={i.attempt}
                link={
                  i.assessment_method === 'last'
                    ? `/test/${i.id}/result`
                    : `/test/${i.id}/best_result`
                }
                resourceLink={`/test/${i.step_id}`}
                course={i.course_title}
              />
            )
            // ))
          )}
      </div>
    </div>
  )
}
export default TableTests
